import { render, staticRenderFns } from "./NoteMoveModal.vue?vue&type=template&id=2ffbb4e0&scoped=true&"
import script from "./NoteMoveModal.vue?vue&type=script&lang=js&"
export * from "./NoteMoveModal.vue?vue&type=script&lang=js&"
import style0 from "./NoteMoveModal.vue?vue&type=style&index=0&id=2ffbb4e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ffbb4e0",
  null
  
)

export default component.exports